<template>
  <button
    ref="button"
    class="button-default"
    :class="`button-${buttonColor} ${status}`"
    @click="eventButton"
    :style="style"
    :disabled="status == 'disabled' ? true : false"
  >{{textButton}} <span class="subtext">{{subTextButton}}</span></button>
</template>
<script>
import { Bus } from "../../event-bus.js";
export default {
  props: {
    textButton: {
      type: String,
      required: true
    },
    subTextButton: {
      type: String,
      required: false
    },
    buttonColor: {
      type: String
    },
    height: {
      type: String
    },
    actionName: {
      type: String
    },
    status: {
      type: String,
      default: "able"
    },
    buttonType: {
      type: String
    },
    noStyle : {
        type: Boolean,
        default : false
    }
  },
  data() {
    return {
      buttonStyle: "",
      colors: {}
    };
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
  },
  methods: {
    eventButton() {
      this.effectButton();
      this.$emit("eventButtonDefault");
      this.actionName ? Bus.$emit(`${this.actionName}`) : "";
    },
    effectButton() {
      let buttonDefault = this.$refs.button;
      let self = this;
      buttonDefault.classList.add(`button-${this.buttonColor}`);
      buttonDefault.classList.add(`button-effect-${this.buttonColor}`);
      setInterval(function() {
        buttonDefault.classList.remove(`button-effect-${self.buttonColor}`);
      }, 200);
    }
  },
  computed: {
    style() {
      if(this.noStyle) return
      if (this.buttonType == "primary") {
        return {
          color: "#fff",
          background: this.status ==  'disabled' ? '#e2e2e2' :this.colors.secondary,
          borderBottom: `4px solid ${this.colors.theme == 'dark' ? "#000" : "#c7c7c7"}`,
          height: this.height,
          
        };
      }
      return {
        background: this.status ==  'disabled' ? '#e2e2e2' :this.colors.secondary,
        borderBottom: `4px solid ${this.colors.theme == 'dark' ? "#000" : "#c7c7c7"}`,
        height: this.height,
        
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.button-default {
  width: 100%;
  // background-color: #fff576;
  height: 40px;
  border: none;
  // border-bottom: 5px solid #e9a661;
  font-weight: bold;
  font-size: 30px;
  outline: none;
  letter-spacing: 2px;
  cursor: pointer;
  text-transform: uppercase;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  

  .subtext{
    font-size: 11px;
    font-weight: 100;
  }
}

.disabled {
  background-color: #dcdcdc;
  border-bottom: 5px solid #d4dcdc;
  color: #fff;
}

.button-effect-yellow {
  border-top: 5px solid #6af6ed;
  border-bottom: #fff576;
}

.button-white {
  background-color: #ffffff;
  border-bottom: 5px solid #e0e0e0;
}

.button-effect-white {
  border-top: 5px solid #6af6ed;
  border-bottom: #ffffff;
}
</style>
